<template>
    <div>
        <!--<pageheading/>-->
        <!--<div class="uk-padding">
            <div class="uk-container">

            </div>
        </div>-->
        <our-legacy/>
        <under-graduate-admissions/>
        <online-admission/>
        <graduate-admissions/>

    </div>
</template>

<script>
    import Pageheading from "../components/shared/pageheading";
    import UnderGraduateAdmissions from "../components/generaladmission/undergraduateAdmissions";
    import GraduateAdmissions from "../components/generaladmission/graduateAdmissions";
    import OnlineAdmission from "../components/generaladmission/onlineAdmission";
    import ApplyNow from "../components/generaladmission/applyNow";
    import OurLegacy from "../components/generaladmission/ourLegacy";
    export default {
        name: "GeneralAdmission",
        components: {
            OurLegacy,
            UnderGraduateAdmissions, ApplyNow, OnlineAdmission, GraduateAdmissions, Pageheading}
    }
</script>

<style scoped>

</style>